import { Select } from "antd";
import styled from "styled-components";

export const MultiSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMultiSelect = styled(Select)`
  min-width: 280px;
  width: 280px;
  height: 35px;
  
  .ant-select-selector {
    border-radius: 8px !important;
    border: 1px solid rgba(217, 217, 217, 0.8) !important;
    background-color: rgba(255, 255, 255, 1) !important;
    height: 35px !important;
    align-items: center !important;
    font-family: "Open Sans" !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: rgba(68, 68, 68, 1) !important;
    transition: all 0.2s ease-in-out !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04) !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(68, 68, 68, 0.6) !important;
    opacity: 1 !important;
  }

  .ant-select-selection-item {
    color: rgba(68, 68, 68, 1) !important;
    background-color: rgba(17, 167, 217, 0.1) !important;
    border: 1px solid rgba(17, 167, 217, 0.3) !important;
    border-radius: 4px !important;
    margin: 2px !important;
    padding: 4px 8px !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 4px !important;
    height: auto !important;
    line-height: 1.2 !important;
  }

  .ant-select-selection-item-content {
    flex: 1 !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item-remove {
    color: rgba(17, 167, 217, 1) !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 14px !important;
    height: 14px !important;
    border-radius: 2px !important;
    transition: background-color 0.2s ease !important;
    
    &:hover {
      background-color: rgba(17, 167, 217, 0.2) !important;
    }
    
    .anticon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }

  &:focus,
  &:hover {
    .ant-select-selector {
      border-color: rgba(17, 167, 217, 0.6) !important;
      box-shadow: 0 2px 8px rgba(17, 167, 217, 0.15) !important;
    }
  }

  .ant-select-arrow {
    color: rgba(68, 68, 68, 0.8) !important;
    font-size: 16px !important;
    transition: transform 0.2s ease-in-out !important;
    margin-right: 8px !important;
    position: relative !important;
    z-index: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    pointer-events: none !important;
  }

  &.ant-select-open .ant-select-arrow {
    transform: rotate(180deg) !important;
  }

  /* Garantir que a arrow seja sempre visível */
  .ant-select-selection-search {
    margin-right: 30px !important;
  }

  .ant-select-selection-overflow {
    margin-right: 30px !important;
  }

  /* Forçar visibilidade do suffixIcon personalizado */
  .ant-select-suffix {
    color: rgba(68, 68, 68, 0.8) !important;
    font-size: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    pointer-events: none !important;
    margin-right: 8px !important;
    z-index: 2 !important;
  }

  &.ant-select-multiple .ant-select-suffix {
    display: flex !important;
  }

  /* Força a exibição do suffix icon mesmo em modo múltiplo */
  .ant-select-show-arrow .ant-select-suffix {
    opacity: 1 !important;
    visibility: visible !important;
  }

  &.ant-select-multiple.ant-select-show-arrow .ant-select-suffix {
    opacity: 1 !important;
    visibility: visible !important;
    display: flex !important;
  }
`;